import { getVehicles } from '../../../api/search-api';
import { getVehiclesFromRVC } from '../../../api/rvc-api';
import { Vehicle } from '../../../api/types';
import {
    buildOrderedVehicleTileList,
    buildVehicleTilesListFromVehicleList,
    getSortedViewedVehicleStockNumbersByDate,
} from '../../../utilities/vehicleTileBuilder';
import { getStoreId } from '../../../utilities/visitor-cookie';
import { getStoreZipCode } from '../../../utilities/cookieHelper';
import { getSavedVehicles } from '../../../utilities/savedVehicles';
import { IViewedVehicleLocalStorage } from '../utilities/types';
import { filterOutExpiredVehicles, getExpirationDate, getLocalStorageItem } from '../utilities/helpers';
import { viewedVehiclesLocalStorage } from '../utilities/constants';

export const getVehiclesForRecentlyViewedTiles = async () => {
    let savedStockNumbers: number[] = [];
    await getSavedVehicles((stockNumbers) => (savedStockNumbers = stockNumbers));
    const viewedVehicles: IViewedVehicleLocalStorage[] = getLocalStorageItem(viewedVehiclesLocalStorage.key) || [];

    const expirationDate = getExpirationDate();
    const filteredVehicles = filterOutExpiredVehicles(viewedVehicles, expirationDate);

    const sortedViewedVehicleStocknumbers = getSortedViewedVehicleStockNumbersByDate(filteredVehicles);
    if (sortedViewedVehicleStocknumbers.length === 0 && savedStockNumbers.length === 0) {
        return [];
    }

    const dedupedAndSortedViewedStockNumbers = sortedViewedVehicleStocknumbers.filter(
        (stocknumber) => !savedStockNumbers.includes(stocknumber),
    );

    const requestedStockNumbers = [...savedStockNumbers, ...dedupedAndSortedViewedStockNumbers];
    const vehiclesList = await getVehicles({
        stockNumberList: requestedStockNumbers,
        take: 10,
        transferDestinationStoreId: getStoreId(),
        zipCode: getStoreZipCode(),
    });

    let missingVehiclesList: number[] = [];
    if (requestedStockNumbers.length !== vehiclesList.length) {
        const foundStockNumbers = vehiclesList.map((v) => v.stockNumber);
        missingVehiclesList = requestedStockNumbers.filter((stockNumber) => !foundStockNumbers.includes(stockNumber));
    }

    let rvcVehiclesList: Vehicle[] = [];
    if (missingVehiclesList.length > 0) {
        rvcVehiclesList = await getVehiclesFromRVC({
            stockNumberList: missingVehiclesList,
        });
    }

    const combinedVehiclesList = [...vehiclesList, ...rvcVehiclesList];
    if (combinedVehiclesList.length === 0) {
        return [];
    }
    const viewed = buildVehicleTilesListFromVehicleList(
        buildOrderedVehicleTileList(dedupedAndSortedViewedStockNumbers, combinedVehiclesList), // TODO why are we sorting these by timestamp above only to re-sort them by stocknumber here?
    );
    const saved = buildVehicleTilesListFromVehicleList(
        buildOrderedVehicleTileList(savedStockNumbers, combinedVehiclesList),
    );
    // Something about ordering the lists is causing an error on the buying online page
    // Since this is a prod bug, just bandaiding it after we do all the processing
    return [...saved, ...viewed].filter((tile) => tile !== undefined);
};
